"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Mail;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Mail(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Contact"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "mail"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "outline",
    d: "M90,23.4H10c-.053,0-.1.013-.154.016a2.252,2.252,0,0,0-.246.025,2.335,2.335,0,0,0-.248.055c-.073.02-.145.041-.217.067a2.458,2.458,0,0,0-.235.1,2.164,2.164,0,0,0-.2.109,2.353,2.353,0,0,0-.209.145c-.061.047-.121.094-.178.146a2.435,2.435,0,0,0-.185.2c-.032.036-.069.064-.1.1-.017.022-.027.047-.043.069a2.6,2.6,0,0,0-.144.23,2.238,2.238,0,0,0-.108.2,2.308,2.308,0,0,0-.088.232c-.026.078-.054.155-.072.234s-.027.15-.038.226a2.663,2.663,0,0,0-.027.266c0,.028-.008.054-.008.082V74.1A2.5,2.5,0,0,0,10,76.6H90a2.5,2.5,0,0,0,2.5-2.5V25.9A2.5,2.5,0,0,0,90,23.4Zm-5.952,5L50.729,54.481,17.273,28.4ZM12.5,71.6V31.018L49.194,59.626a2.5,2.5,0,0,0,3.078,0L87.5,32.047V71.6Z"
  }))));
}